import { gql } from '@apollo/client';

import { StudentActivitiesActivity } from '@ts-core/modules/billing/types';

export interface GetStudentActivitiesByMonthQueryVariables {
  courseId: string;
  studentId: string;
  year: string;
  month: string;
}

export interface GetStudentActivitiesByMonthQueryResult {
  activities: StudentActivitiesActivity[];
}

export const getStudentActivitiesByMonthQuery = gql`
  query GetStudentActivitiesByMonthQuery($courseId: String!, $studentId: String!, $year: String!, $month: String!) {
    activities(courseId: $courseId, studentId: $studentId, year: $year, month: $month)
      @rest(
        type: "StudentActivitiesActivityByMonth"
        path: "students-activity/years/{args.year}/months/{args.month}/courses/{args.courseId}/students/{args.studentId}/activities"
      ) {
      _id
      name
      answerDate
      file
      score
    }
  }
`;
